import React from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useRemoteConfiguration } from './hooks/useRemoteConfiguration';
import { queryClient as clientQuery } from './client';

const QueryContext = React.createContext(clientQuery);

export const QueryProvider = ({ queryClient = clientQuery, children, clients }) => {
    const { isFinished } = useRemoteConfiguration(queryClient, clients?.appSettingsDataClient);

    if (!isFinished) {
        return null;
    }

    return (
        <QueryContext.Provider value={queryClient}>
            <QueryClientProvider client={queryClient}>
                {children}
                <ReactQueryDevtools initialIsOpen />
            </QueryClientProvider>
        </QueryContext.Provider>
    );
};
